import { message } from "ant-design-vue";
import SparkMD5 from "spark-md5";
import { ref } from "vue";

const percentum = ref(0) as any;
const isCompleted = ref(false);
let currentXhr: XMLHttpRequest | null = null; // 保存当前的 XMLHttpRequest 实例
const uploadLoading = ref<boolean>(false);
const process = ref(false); // 是否正在上传

const progressTimer: any = null;

// 模拟进度增长
// const simulateProgress = () => {
//   if (progressTimer) clearInterval(progressTimer);
//   percentum.value = 0;
//   progressTimer = setInterval(() => {
//     if (percentum.value < 90) {
//       // 速度随进度变化，开始快，后面慢
//       const increment = Math.ceil((90 - percentum.value) * 0.1);
//       percentum.value = Math.min(90, percentum.value + increment);
//     }
//   }, 10);
// };

// 创建文件md5
const createFileMd5 = (file: File): Promise<{ fileMd5: string; fileBlob: Blob }> => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsBinaryString(file);
    fileReader.onload = (e) => {
      const result: any = e.target?.result;
      const isSuccess = file.size === result.length;
      const resultData = {
        fileMd5: SparkMD5.hashBinary(result),
        fileBlob: new Blob([result], { type: file.type }),
      };
      if (isSuccess) {
        resolve(resultData);
      } else {
        reject(new Error("读取出错了"));
      }
    };
    fileReader.onerror = () => reject(new Error("读取出错了"));
  });
};

// 上传到oss
const uploadOSS = (url: string, file: File, progress?: (percent: number) => void): Promise<void> => {
  return new Promise((resolve, reject) => {
    const xhr = (currentXhr = new XMLHttpRequest());
    xhr.open("put", url, true);
    xhr.setRequestHeader("x-oss-meta-author", "aliy");
    xhr.setRequestHeader("Content-type", "application/octet-stream");
    xhr.upload.addEventListener(
      "progress",
      (result) => {
        if (result.lengthComputable) {
          //上传进度
          const percent = (result.loaded / result.total) * 100;
          // percentum.value = percent;
          if (progress) progress(percent);
        }
      },
      false,
    );
    xhr.addEventListener("readystatechange", () => {
      const result = xhr;
      if (result.status !== 200) {
        message.error({
          content: "文件上传失败",
          key: "documentUpload",
        });
        console.error("上传失败", result.status, result.statusText, result.response);
        reject(new Error("上传失败"));
      } else if (result.readyState === 4) {
        resolve();
      }
    });
    xhr.send(file);
  });
};
/**
 *
 * @param file 文件
 * @param getUploadParams 获取临时链接方法
 * @param progress 进度回调
 */
const upload = async (
  file: File,
  getUploadParams: () => Promise<{ tempUrl: string; fileExists: boolean; fileId: string }>,
  progress?: (progressnum: number) => void,
) => {
  try {
    const { tempUrl, fileExists, fileId } = await getUploadParams();
    process.value = true;
    if (!fileExists && tempUrl) {
      await uploadOSS(tempUrl, file, progress);
      isCompleted.value = true;
    }
    if (progressTimer) clearInterval(progressTimer);
    percentum.value = 99; // 上传完成
    return Promise.resolve({ fileId, tempUrl });
  } catch (error) {
    console.error("文件上传失败：", error);
    return Promise.reject(error);
  } finally {
    currentXhr = null;
    isCompleted.value = true;
    process.value = false;
  }
};

const setUploadLoading = (loading: boolean) => {
  uploadLoading.value = loading;
};

export const useLinkUpload = () => {
  percentum.value = 0;
  return {
    createFileMd5,
    upload,
    cancel: () => {
      currentXhr?.abort();
    },
    uploadLoading,
    setUploadLoading,
    percentum,
    process,
  };
};
